import React, {useEffect, useState} from 'react';
import {axios} from "../axios";
import CategoryItem from "../components/category-item";
import CoverLoading from "../components/cover-loading";
import NoteBox from "../components/note-box";

const Region = () => {
    const [titleEn,setTitleEn] = useState('')
    const [titleDe,setTitleDe] = useState('')
    const [status,setStatus] = useState('none')
    const [categories,setCategories] = useState([])
    useEffect(()=>{
        axios.get('/region')
            .then(res=>setCategories(res.data))
            .catch(()=>setCategories([]))
    },[])
    const createCategory = ()=>{
        setStatus('load')
        const formData = new FormData()
        formData.append('title_en',titleEn)
        formData.append('title_de',titleDe)
        axios.post('/region',formData)
            .then(res=>{
                setCategories(res.data.region)
                setStatus(res.data.message)
            })
            .catch(()=>{setStatus('error')})
    }
    return (
        <div className='main-container form position-relative'>
            {status === 'done' ? <NoteBox title='Region created successfully' color='green'/> : ""}
            {status === 'error' ? <NoteBox title='Something went wrong, please try again' color='#dc3545'/> : ""}
            {status === 'updated' ? <NoteBox title='Region updated successfully' color='green'/> : ""}
            {status === 'deleted' ? <NoteBox title='Region deleted successfully' color='green'/> : ""}
            {status === 'load' ? <CoverLoading/> : ''}
            <div className="d-flex w-100 flex-column h-100 justify-content-center align-items-center">
                <div className="d-flex p-1 align-items-center justify-content-center br-5 m-3 mw-100 flex-wrap ">
                    {categories.map(e=>{
                        return <CategoryItem key={e.id} category={e} setCategories={setCategories}
                                             handleStatus={setStatus}/>
                    })}
                </div>
                <div className="bg-white d-flex p-3 align-items-center w-50 justify-content-between br-5">
                    <input type="text" value={titleEn} onChange={e=>setTitleEn(e.target.value)} className='w-100 me-3' placeholder='Title (En)'/>
                    <input type="text" value={titleDe} onChange={e=>setTitleDe(e.target.value)} className='w-100 me-3' placeholder='Title (De)'/>
                    <div className="button button-green" onClick={createCategory}>Create</div>
                    {status !== 'none' ?
                        <span className={`ms-3 small-note ${status === 'done' ? 'text-success' : 'text-danger'}`}>
                            {status === 'done' ? 'Created successfully' : ''}
                            {status === 'error' ? 'oops!' : ''}
                        </span> : ''}
                </div>
            </div>
        </div>
    );
};

export default Region;